import React, { useCallback, useEffect, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import Header from "../components/Header";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tab,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Patientinfo from "../components/Patientinfo";
import LeftNav from "../components/LeftNav";
import PatientStatus from "../components/PatientStatus";
import { apiAxios } from "../Util/ApiAxios";
import { BiXCircle } from "react-icons/bi";
import Loader from "react-loader-spinner";
import reload from "../images/reload.png";
import { Pagination, TabContext, TabList, TabPanel } from "@material-ui/lab";

const MyAppointment = (props) => {
  const classes = useStyles();
  const [patientList, setPatientList] = useState([]);
  const [message, setMessage] = useState("");
  const [Token, setToken] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const currentPageRef = useRef(1);
  const [currentReportPage, setCurrentReportPage] = useState(1);
  const [totalReportPages, setTotalReportPages] = useState(1);

  const [showLoader, setShowLoader] = React.useState(false);
  const [view, setView] = React.useState(null);

  const [openInfo, setOpenInfo] = React.useState(false);

  const [value, setValue] = React.useState("1");

  const handleClickOpen = (selected) => {
    setView(selected);
    setOpenInfo(true);
  };
  const handleClose = (e) => {
    e?.stopPropagation();
    console.log("Modal closed");
    setOpenInfo(false);
  };
  function openPatProgram(data) {
    props.history.push({
      pathname: "/patient-information",
      state: {
        patientInfo: data,
      },
    });
  }
  const getPatientList = useCallback(
    async ({
      table_config_rows_per_page = "15",
      table_config_page_no = "1",
      list_type = "upcoming",
    } = {}) => {
      const userId = JSON.parse(localStorage.getItem("dhct_JWT"))?.user_uuid;
      setCurrentPage(parseInt(table_config_page_no));

      setPatientList([]);
      setMessage("Loading...");

      const status_list =
        list_type === "past" ? ["2", "3", "4", "7"] : ["2", "3", "4"];

      const userData = {
        user_id: userId,
        status_list,
        visit_type: 0,
        table_config_rows_per_page: table_config_rows_per_page,
        table_config_page_no: table_config_page_no,
        list_type,
        appointment_type: "0",
        pattern: "",
        sorting: {
          appointment_date: "DESC",
          start_time: "DESC",
        },
      };
      console.log("Data", userId);

      apiAxios
        .post("/user/appointment-list", userData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("response --> ", response);
          if (response.data.statusCode == 200) {
            setPatientList(response.data.appointments);

            setMessage("");
            setTotalPages(response.data.total_pages_count);
          } else if (response.data.statusCode == 502) {
            setMessage("No Data Found");
          } else {
            setMessage(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          localStorage.removeItem("dhct_Refresh_Token");
          localStorage.removeItem("dhct_Token");
          // window.location.href = "/";
        });
    },
    []
  );

  useEffect(() => {
    getPatientList({ list_type: "upcoming" });
  }, []);

  const handleChange2 = (event, newValue) => {
    setValue(newValue);

    if (newValue === "1") {
      getPatientList({ list_type: "upcoming" });
    } else if (newValue === "2") {
      getPatientList({ list_type: "past" });
    }
  };

  return (
    <div>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      <Header />
      <Box className={classes.pagecontent}>
        <Box className={classes.leftcol}>
          <Box className={classes.leftnav} style={{ marginTop: "40px" }}>
            {localStorage.getItem("dhct_JWT") ? <PatientStatus /> : <></>}
          </Box>
        </Box>
        <Box className={classes.Rightcol}>
          <Box className={classes.Tabcol}>
            <TabContext value={value}>
              <AppBar position="static" className={classes.contacttab}>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <TabList
                    onChange={handleChange2}
                    aria-label="simple tabs example"
                  >
                    <Tab label="Pending Appointments" value="1" />
                    <Tab label="Past Appointments" value="2" />
                  </TabList>
                </Box>
              </AppBar>
              <TabPanel value="1">
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "10px",
                  }}
                >
                  <Box className={classes.iconBox}>
                    <img
                      src={reload}
                      alt="reload-icon"
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                      onClick={() => getPatientList({ list_type: "upcoming" })}
                    />
                  </Box>
                </Box>
                <Box className={classes.PatientListTable}>
                  <Box className={classes.throw}>
                    <Box className={classes.patient}>Patient Name</Box>
                    <Box className={classes.date}>Date</Box>
                    <Box className={classes.hrpmID}>HRPM ID</Box>
                    <Box className={classes.purpose}>Purpose</Box>
                    <Box className={classes.stime}>Start Time</Box>
                    <Box className={classes.etime}>End Time</Box>
                    <Box className={classes.view}>View</Box>
                  </Box>
                  {patientList.length > 0 ? (
                    <>
                      {patientList.map((each) => (
                        <Box
                          key={each.appointment_number}
                          className={classes.tdrow}
                          onClick={() => handleClickOpen(each)}
                        >
                          <Box className={classes.patient}>
                            {`${each.patient_first_name} ${each.patient_last_name}`}
                          </Box>
                          <Box className={classes.date}>
                            {each.appointment_date}
                          </Box>
                          <Box className={classes.hrpmID}>{each.hrpm_id}</Box>
                          <Box className={classes.purpose}>
                            {each.purpose_of_consultation}
                          </Box>
                          <Box className={classes.stime}>{each.start_time}</Box>
                          <Box className={classes.etime}>{each.end_time}</Box>
                          <Box
                            className={classes.view}
                            onClick={() => openPatProgram(each)}
                          >
                            <b style={{ color: "#88b3eb" }}>View</b>
                          </Box>
                        </Box>
                      ))}
                    </>
                  ) : (
                    <Box style={{ marginTop: "30px", textAlign: "center" }}>
                      {message ? message : "No Appointments Found"}
                    </Box>
                  )}
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "right",
                      justifyContent: "right",
                    }}
                  >
                    <Pagination
                      count={totalPages}
                      color="primary"
                      page={currentPage}
                      onChange={(event, pageNumber) =>
                        getPatientList({
                          table_config_page_no: `${pageNumber}`,
                          list_type: "upcoming",
                        })
                      }
                    />
                  </div>
                </Box>
              </TabPanel>
              {/* tab panel 2 */}
              <TabPanel value="2">
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "10px",
                  }}
                >
                  <Box className={classes.iconBox}>
                    <img
                      src={reload}
                      alt="reload-icon"
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                      onClick={() => getPatientList({ list_type: "past" })}
                    />
                  </Box>
                </Box>
                <Box className={classes.PatientListTable}>
                  <Box className={classes.throw}>
                    <Box className={classes.patient}>Patient Name</Box>
                    <Box className={classes.date}>Date</Box>
                    <Box className={classes.hrpmID}>HRPM ID</Box>
                    <Box className={classes.purpose}>Purpose</Box>
                    <Box className={classes.stime}>Start Time</Box>
                    <Box className={classes.etime}>End Time</Box>
                    <Box className={classes.view}>View</Box>
                  </Box>
                  {patientList.length > 0 ? (
                    <>
                      {patientList.map((each) => (
                        <Box
                          key={each.appointment_number}
                          className={classes.tdrow}
                          onClick={() => handleClickOpen(each)}
                        >
                          <Box className={classes.patient}>
                            {`${each.patient_first_name} ${each.patient_last_name}`}
                          </Box>
                          <Box className={classes.date}>
                            {each.appointment_date}
                          </Box>
                          <Box className={classes.hrpmID}>{each.hrpm_id}</Box>
                          <Box className={classes.purpose}>
                            {each.purpose_of_consultation}
                          </Box>
                          <Box className={classes.stime}>{each.start_time}</Box>
                          <Box className={classes.etime}>{each.end_time}</Box>
                          <Box
                            className={classes.view}
                            onClick={() => openPatProgram(each)}
                          >
                            <b style={{ color: "#88b3eb" }}>View</b>
                          </Box>
                        </Box>
                      ))}
                    </>
                  ) : (
                    <Box style={{ marginTop: "30px", textAlign: "center" }}>
                      {message ? message : "No Appointments Found"}
                    </Box>
                  )}
                  <Box
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "right",
                      justifyContent: "right",
                    }}
                  >
                    <Pagination
                      count={totalPages}
                      color="primary"
                      page={currentPage}
                      onChange={(event, pageNumber) =>
                        getPatientList({
                          table_config_page_no: `${pageNumber}`,
                          list_type: "past",
                        })
                      }
                    />
                  </Box>
                </Box>
              </TabPanel>
            </TabContext>
          </Box>

          <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openInfo}
          >
            <DialogContent className={classes.ccmmodal}>
              <Typography
                variant="h3"
                style={{
                  fontSize: 18,
                  fontFamily: "poppins",
                  fontWeight: "600",
                }}
              >
                My Appointments
              </Typography>
              <Box className={classes.btncol}>
                <Button onClick={handleClose} className={classes.closebtn}>
                  <BiXCircle className={classes.closeicon} />
                </Button>
              </Box>
              <DialogContentText id="alert-dialog-slide-description">
                {view ? (
                  <Typography>
                    From Patient List go to HRPM-ID {view.hrpm_id} to start the
                    consultation
                  </Typography>
                ) : null}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {showLoader ? (
                <Loader
                  type="ThreeDots"
                  color="#000000"
                  height={50}
                  width={50}
                  timeout={0} //30 secs
                />
              ) : (
                <Button
                  size="large"
                  className={classes.Deletebtn}
                  onClick={handleClose}
                >
                  Close
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    </div>
  );
};

export default MyAppointment;
const useStyles = makeStyles(() => ({
  pagecontent: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    "& a": {
      textDecoration: "none",
    },
  },
  Rightcol: {
    width: "75%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: "33%",
    },
    "& .MuiTab-root:nth-child(6)": {
      minWidth: "30%",
    },
    "& .MuiTab-root:nth-child(7)": {
      minWidth: "30%",
    },
  },
  contacttab: {
    background: "#fff",
    boxShadow: "none",
    color: "#000",
    textTransform: "capitalize",
    "& .MuiTabs-indicator": {
      display: "none !important",
    },
    "& .MuiTabs-flexContainer": {
      borderRadius: "10px",
      background: "#F3F3F3",
      width: "400px",
      textTransform: "capitalize",
      overflow: "hidden",
      "& .MuiTab-textColorInherit.Mui-selected": {
        background: "#0f3d6e",
        color: "#ffffff",
      },
      "& .MuiTab-textColorInherit": {
        textTransform: "capitalize",
        fontSize: "16px",
        padding: "0 22px",
      },
      "& .MuiTabPanel-root": {
        padding: "24px 0",
      },
    },
  },

  leftcol: {
    width: "15%",
    padding: "20px 3%",
    minHeight: "800px",
    background: "linear-gradient(-45deg, #114ebd, #0f3d6e)",
    position: "relative",
    "@media only screen and (max-width: 820px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "@media only screen and (max-width: 768px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "& ul": {
      listStyle: "none",
      margin: "0px",
      padding: "0px",
      "& li": {
        color: "#1C295D",
        fontSize: "12px",
        fontWeight: "500",
      },
      "& li button": {
        background: "#f1f1f1",
        width: "150px",
        height: "55px",
        margin: "8px 0",
        textAlign: "center",
        color: "#0f3d6e",
        borderRadius: "10px",
        fontSize: "18px",
        "&:hover": {
          background: "#0f3d6e",
        },
      },
    },
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  TopfilterLeft: {
    width: "50%",
    "@media only screen and (max-width: 820px)": {
      width: "70%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "70%",
    },
  },
  TopfilterRight: {
    width: "50%",
    "@media only screen and (max-width: 820px)": {
      width: "30%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "30%",
    },
  },
  PatientTable: {
    width: "100%",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        overflowX: "auto",
      },
  },
  Toptext: {
    margin: 0,
    fontFamily: "poppins",
    fontSize: 18,
    color: "#000",
    fontWeight: "500",
  },
  chartbtn: {
    background: "#0f3d6e",
    borderRadius: "10px",
    padding: "0 20px",
    height: "40px",
    color: "#fff",
    textTransform: "capitalize",
    fontSize: "14px",
    cursor: "pointer",
    "&:hover": {
      background: "#333",
    },
  },
  throw: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "2px #E3E5E5 solid",
    fontSize: "14px",
    color: "#fff",
    paddingBottom: "5px",
    background: "linear-gradient(to left, #114ebd, #0f3d6e)",
    padding: 6,
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  tdrow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px #E3E5E5 solid",
    fontSize: "14px",
    padding: "10px 0",
    cursor: "pointer",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  providerbtn: {
    display: "flex",
    cursor: "pointer",
    "& span": {
      display: "flex",
      flexDirection: "column",
      width: "20px",
      marginRight: "10px",
      "& button": {
        background: "none",
        border: "none",
        height: "10px",
        cursor: "pointer",
      },
    },
  },
  patient: {
    width: "15%",
    textAlign: "left",
  },
  date: {
    width: "10%",
    textAlign: "left",
    wordWrap: "break-word",
    overflow: "auto",
  },
  hrpmID: {
    width: "5%",
    textAlign: "left",
    wordBreak: "break-all",
  },
  purpose: {
    width: "45%",
    textAlign: "center",
    wordBreak: "break-all",
  },
  view: {
    width: "5%",
    textAlign: "center",
    wordBreak: "break-all",
  },
  etime: {
    width: "10%",
    textAlign: "center",
    cursor: "pointer",
  },
  stime: {
    width: "10%",
    textAlign: "center",
    cursor: "pointer",
  },
  planbtn: {
    fontSize: "12px",
    color: "#fff",
    background: "#0f3d6e",
    textTransform: "capitalize",
    padding: "0px 5px",
    "&:hover": {
      background: "#333",
    },
  },
  pageTop: {
    textAlign: "left",
    "& button": {
      padding: "0px",
      background: "none",
      color: "#bfc4cb",
      fontSize: "15px",
      textTransform: "capitalize",
      fontWeight: "500",
    },
  },
  backarrow: {
    color: "#b4bcc9",
    fontSize: "20px",
    marginRight: "8px",
  },
  Searchresult: {
    "& h4": {
      fontSize: "16px",
      color: "#0f3d6e",
      fontWeight: "500",
      margin: "40px 0",
      textAlign: "left",
    },
  },
  btncol: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 40,
    alignItems: "center",
  },

  Topfilter: {
    width: "100%",
    display: "flex",
    marginTop: 30,
    marginBottom: 50,
    flexDirection: "row",
    "& label": { color: "#666", marginBottom: 5, display: "flex" },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-formControl": {
      height: "50px",
    },
    "& .MuiInput-input:focus": {
      border: "1px #0074D9 solid",
      boxShadow: "2px 2px 10px 1px rgba(0,0,0,0.3)",
    },
    "& .MuiInputBase-input": {
      height: "50px",
      borderRadius: "10px",
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 15px",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
  Searchbtn: {
    background: "#0f3d6e",
    borderRadius: 10,
    display: "flex",
    color: "#fff",
    height: 50,
    paddingLeft: 30,
    paddingRight: 30,
    marginLeft: 15,
    textTransform: "capitalize",
    marginTop: 28,
    "&:hover": {
      background: "rgba(0,0,0,0.8)",
    },
  },
  loginbtn: {
    background: "#1612C6",
    padding: "0 40px",
    height: "45px",
    borderRadius: "10px",
    color: "#fff",
    marginTop: "20px",
    fontFamily: "poppins",
    textTransform: "capitalize",
    fontSize: 14,
    "&:hover": {
      background: "#000",
    },
  },

  Formcol: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    "&>div": {
      width: "100%",
    },
    "& p": {
      fontSize: "18px",
      margin: "0px",
    },
    "& label": {
      flex: "0 0 205px",
      color: "#000",
      fontSize: "15px",
      fontWeight: "400",
    },
    "& .react-dropdown-select-input": {
      width: "100%",
    },
  },
  select: {
    width: "100%",
    border: "none !important",
    borderRadius: "10px !important",
    border: "1px #D5D5D5 solid",
    backgroundColor: "#F9F9F9",
    height: "50px",
    fontSize: "14px !important",
    paddingLeft: "15px !important",
    paddingRight: "15px !important",
    "& .react-dropdown-select-input": {
      // display: 'none'
    },
  },
  modal: {
    "& .MuiPaper-rounded": {
      borderRadius: "10px !important",
      padding: "20px",
      width: "550px",
      maxWidth: "550px",
    },
  },
  ccmmodal: {
    borderRadius: "10px",
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-formControl": {
      height: "50px",
    },
    "& .MuiInput-input:focus": {
      border: "1px #0074D9 solid",
      boxShadow: "2px 2px 10px 1px rgba(0,0,0,0.3)",
    },
    "& .MuiInputBase-input": {
      height: "50px",
      borderRadius: "10px",
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 15px",
    },
    "& .react-date-picker__wrapper": {
      borderRadius: 10,
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 10px",
    },
  },
  closebtn: {
    width: "40px",
    position: "absolute",
    right: "10px",
    height: "40px",
    background: "#fff",
    top: "10px",
    minWidth: "40px",
    "&:hover": {
      background: "#fff",
    },
  },
  closeicon: {
    fontSize: "25px",
    color: "#7087A7",
  },
  icon: {
    color: "#7087A7",
    fontSize: "20px",
    marginRight: "10px",
  },
  input: {
    border: "none",
    borderRadius: "10px",
    height: "50px",
    width: "100%",
  },
  topheading: {
    fontSize: "18px",
    color: "#000",
    fontWeight: "500",
    alignSelf: "flex-start",
  },
  PatientListTable: {
    width: "100%",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        overflowX: "auto",
      },
  },
  Deletebtn: {
    background: "#fff",
    border: "1px #f12626 solid",
    width: "60px",
    height: "30px",
    float: "right",
    color: "#f12626",
    textTransform: "capitalize",
    borderRadius: "10px",
    fontWeight: "600",
    "&:hover": {
      background: "#f12626",
      color: "#fff",
    },
  },
  iconBox: {
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "999px",
    cursor: "pointer",
    "&:hover": {
      background: "#ddd",
      color: "#fff",
    },
  },
}));
